import React, { Component } from 'react';
import { browserName, browserVersion } from 'react-device-detect';
import UserContext from "../tools/contextLib";
import { Collapse, Container, Navbar, NavbarBrand, Nav, NavbarToggler, NavItem, NavLink, Dropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap';
import { Link } from 'react-router-dom'; 
import './NavMenu.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import '../custom.css'
import { AiOutlineInfoCircle } from 'react-icons/ai';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

//import store from './store'
import { connect } from 'react-redux';

class NavMenu extends Component {
    static displayName = NavMenu.name; //todo: I'm pretty sure this is supposed to change the site's name in the tab. Confirm this works, and if it doesn't make it

    constructor(props) {
        super(props);
        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.toggle = this.toggle.bind(this);
        this.state = { //There's gotta be at least one of these we're not using anymore. todo: figure out which one it is and remove it
            collapsed: true,
            dropdownOpen: false,
            returnable: this.props.reduxData.userInfo,
            pages: this.props.initPages, 
            loading: true,
            profile: null,
            globalLevel: "",
            IP: "",
            showWindowPortal: false,
            pageName: "Home",
            pageHelpURL: "Home.pdf",
            browser: `${browserName}${browserVersion}`, //This returns browser information just as "Chrome98" for example, which isn't as descriptive as I guess it could be (no platform information)
                                                        //but it's all the information we really need and looks better than a gigantic string of all sorts of weird data
            bearerVAR: "Bearer "
        };
        //this.getData();//We need these two to be invoked in constructor(props) to make sure the data they're retrieving is present in the component when it's rendered. If 
                       //they're in componentDidMount() there's this awkward moment where the page has rendered but there's nothing there since the fetch is still waiting for response
        this.populateDropdown();//One could probably be invoked in the other to make sure they're firing in serialized fashion, but it's not important enough to worry about
        this.toggleWindowPortal = this.toggleWindowPortal.bind(this);
        this.closeWindowPortal = this.closeWindowPortal.bind(this);
    }

    componentDidMount() {
        window.addEventListener('beforeunload', () => {
            this.closeWindowPortal();
        });
        window.setInterval(() => {
            this.setState(state => ({
                counter: state.counter + 1,
            }));
        }, 1000);
    }

    async checkPageName() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        const response = await fetch('PageName', { method: 'GET', headers: { 'Authorization': bearerVAR }});
        const data = await response.json();
        if (this.state.pageName != data.name) {
            this.setState({
                pageName: data.name,
                //pageHelpURL: data.helpurl
            })
        }
        if (data.helpurl != '') {
            this.setState({
                pageHelpURL: data.helpurl
            })
        }
        else {
            this.setState({
                pageHelpURL: "UnderConstruction.pdf"
            })
        }
        //localStorage.setItem("lastFetch", moment());
        this.props.updateFetchTime();
    }

    async getData() { //Beware: when this was first implemented, this only worked once every five logging posts. After seemingly changing nothing, it's now working on every one.
                      //I don't know what arcane magic is responsible, but if you start seeing Webpage_Usage having logs with a blank IP field this is why.
                      //This get can also provide country, city, zip code, state, and GPS coordinates
        const response = await axios.get('https://geolocation-db.com/json/');
        this.setState({
            IP: response.data.IPv4
        });
        //console.log("redux prop: ", this.props.reduxData)
        //console.log("redux subprop: " , this.props.reduxData.apiKey)
    }

    toggleWindowPortal() {//WindowPortal doesn't seem to be used. todo: remove it when not just writing more documentation. If it's actually important removing it is something to be handled lightly
        this.setState(state => ({
            ...state,
            showWindowPortal: !state.showWindowPortal,
        }));
    }

    closeWindowPortal() {
        this.setState({ showWindowPortal: false })
    }

    async getPages(dept) {
        let toSend = {
            level: dept
        }
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        const response = await fetch('PageFind', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': bearerVAR
            },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        this.setState({
            pages: data
        })
        //localStorage.setItem("lastFetch", moment());
        this.props.updateFetchTime();
    }

    toggleNavbar() {//This will switch the hamburger menu that contains the links to the locations from open to closed. 
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    changeTitle(data, url, pk) { //When a link in the hamburger menu is selected, this function fires to change the title at the top-center of the navigation header
                        //An unfortunate side-effect of this is that if you refresh the page on a page-type component other than Home, the title changes to "Home"
                        //Low priority fix, look into it if someone complains
                        //UPDATE: fixed by having page display control in App.js, and as a consequence having a refresh landing the user back on Home as a matter of course
        this.setState({
            pageName: data,
        })
        if (url != '') {
            this.setState({
                pageHelpURL: url
            })
        }
        else {
            this.setState({
                pageHelpURL: "UnderConstruction.pdf"
            })
        }
        this.toggleNavbar();
        this.props.passNewPage(pk);
    }

    toggle() { //This fires whenever a user clicks on the user permission level dropdown, and switches its display from open to closed and back
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }

    onDropdownSelected(e) {
        this.setState({ dropdownOpen: true });
    }

    setLevel = (e) => {
        //This function is a little barren because most of its functionality was moved within this.sendData() to make sure functions are executed in the proper order
        //The invokation in render() could probably be switched to this.sendData() because of that
        e.preventDefault();
        console.log("selecting: " + e.currentTarget.value)
        this.sendDataNew(e.currentTarget.value)
    }

    logout() {
        localStorage.removeItem("webApiAccessToken");
        localStorage.removeItem("lastFetch");
        this.props.logoutPROP();
    }

    //this.state.pageName

    render() {
        let pages = this.state.pages
        pages.sort((a, b) => {
            if (a.pageName.toUpperCase() < b.pageName.toUpperCase()) {
                return -1;
            }
            if (a.pageName.toUpperCase() > b.pageName.toUpperCase()) {
                return 1;
            }
            return 0;
        })
        //old shield logo:
        //https://www.hood.edu/sites/default/files/Marcom/Templates/1C_Shield_NO1893.png
        return (
            <UserContext.Consumer>
                {contextData => (
                    <header >
                        <Navbar collapseOnSelect expand={false} className="ng-white border-bottom box-shadow mb-3" light>
                            <Container>
                                <NavbarBrand href="https://www.hood.edu"><img src={'https://www.hood.edu/media/60296'} alt="Hood College" className="bannerImage" /></NavbarBrand>
                                <div className="testClassDIV inlineCustom"><h3 className="inlineCustom">{this.state.pageName}&nbsp;</h3>
                                    <a href="#" className="inlineCUstom" onClick={(e) => { window.open("/Documents/HelpFiles/" + this.state.pageHelpURL, '', 'width=1200,height=800,left=400,top=400'); e.preventDefault(); }}><AiOutlineInfoCircle /></a><br />
                                    </div>
                                <div className="inlineCustom"></div>
                                {/*<div className=" inlineCustom rightAlignCustom"><Button onClick={() => this.logout() }>Log Out</Button></div>*/}
                                {contextData[0] != "" && contextData[0] != null && < div className="dropdownDIV">
                                    <Dropdown inNavbar={true} isOpen={this.state.dropdownOpen} onChange={this.onDropdownSelected} toggle={this.toggle}>
                                        <DropdownToggle caret>
                                            {contextData[0]}
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            {contextData[2].map(size => (
                                                <DropdownItem onClick={this.setLevel} value={size.pk + "|" + size.display}>{size.display}</DropdownItem>))}
                                        </DropdownMenu>
                                    </Dropdown>
                                </div>}
                                <Nav className="mr-auto" navbarScroll>
                                    <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                                    <Collapse isOpen={!this.state.collapsed}  navbar>
                                        <ul className="navbar-nav flex-grow">
                                            <NavItem>
                                                <NavLink tag={Link} className="text-dark nav-link" onClick={() => this.changeTitle("Home", 'Home.pdf',"/Home")}>Home</NavLink>
                                                {/*<NavLink tag={Link} className="text-dark nav-link" onClick={() => this.changeTitle("Employee Directory", 'EmployeeDirectory.pdf', 6)}>Employee Directory</NavLink>*/}
                                                {/*{contextData[0].substring(0, contextData[0].indexOf('-')) != 'STUDENTS ' &&*/}
                                                {/*    contextData[0].substring(0, contextData[0].indexOf('-')) != 'ALUMNI ' &&*/}
                                                {/*    <NavLink tag={Link} className="text-dark nav-link" onClick={() => this.changeTitle("Distribution List Management", '', 1041)}>Distribution List Management</NavLink>}*/}
                                                
                                                {/*{contextData[5].map(size => (*/}
                                                {pages.map(size => (
                                                    <NavLink tag={Link} className="text-dark nav-link"  onClick={() => this.changeTitle(size.pageName, size.pagehelpurl, size.pageURL)}>{size.pageName}</NavLink>))}
                                            </NavItem>
                                        </ul>
                                    </Collapse>
                                </Nav>
                            </Container>
                        </Navbar>
                    </header>)}
            </UserContext.Consumer>
        ); /*
         * 
         *                                            to={size.pageURL}    
         * 
         * 
         * We use UserContext here to retrieve as much information from App.js as we can. This is to try and ensure everywhere that needs this information is definitely using the same information
         * even though the fetch('user') is looking at the same place each time and should be getting the same information.
         * However, context is only visible within render({return()}). In order for this information to be visible elsewhere in the child components, it needs to be either passed as a prop
         * which can get irritatingly long for many values to pass, or fetched by the child components individually. Work will be done on efficiently passing this data as props, which is 
         * why there's still going to be a bunch of fetch('user') functions in this project for a while
         * 
         * An issue that I've noticed is that the default value for this.state.pageName means that when you refresh on a page the name becomes "Home" instead of what component you're 
         * actually on. This can probably be solved by more controllers and database queries, but possible behaviors of this make me anxious. Nevertheless it's what's probably
         * going to be done, so for future reference: try looking up the last visited page on Webpage_Usage and comparing its PK to the Webpages table (look for PageDisplayName). This
         * may run into issues on initial load if the post to it hasn't written by the time the title needs to populate which is the part that makes me wary. Alternatively, using
         * setPageTitle from props may be able to make this work easier, it's worth investigating before doing lots of unnecessary work.
         * UPDATE:resolved. We're moving away from Routing to page components and instead using conditional rendering based on webpage PK to decide which component to display. This means every
         * refresh lands the user back on Home, so the user clicking on the nav link is the way users get to pages
         * 
         * This render shows the navbar brand as the single-color Hood shield without date, the list below it of all of the sites on the page, and to the right side of the page the dropdown
         * This is clunky because it was done without using custom.css, in the future I will use it extensively.
         * todo: add the active user's name just above the dropdown, fix title to not show "Home" on refresh, other stylistic choices
         * 
         * With respect to the stylistic choices, because this website is called "Under The Hood" and is supposed to be a direct line to database functionality, I have envisioned it to be a 
         * style that looks and feels like a steel-thread design. It should hopefully be the website equivalent of a maintenance corridor, with less mold.
         * */
    }

    async populateDropdown() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        //console.log("NavMenu populateDropdown bearerVAR: " + bearerVAR)
        //const response = await fetch('user', { headers: { 'Authorization': bearerVAR } });
        //const data = await response.json();
        this.setState({
            returnable: this.props.reduxData.userInfo,
            loading: false,
            selectables: this.props.reduxData.userInfo.values, //We explicitly state this because trying to map through this.props.reduxData.userInfo.values was having trouble. This has been supplanted by context data
        });
        this.setState({//This is done separately because globalLevel is changed by a few other things, in particular the dropdown, and we want to make sure it's being set properly
            globalLevel: this.props.reduxData.userInfo.level.pk
        })
        this.getPages(this.props.reduxData.userInfo.level.pk);
        //this.getPages(this.state.globalLevel);
        //this.checkPageName();
        //localStorage.setItem("lastFetch", moment());
        this.props.updateFetchTime();
    }
    
    async sendData(t) {
        //console.log("send data: " + t)
         let toSend = {
             pagePK: "levelChange", //The fetch we're using this JSON for calls the same controller that logs when a site has changed. However, when we change our level, 
                                    //we're staying on the same site. This string is used as an indicator to the controller that this needs to be a level switch and not a page switch
             department: t,
             userPCID: this.props.reduxData.userInfo.pcid,
             ip: this.props.reduxData.userInfo.ip,
             browser: this.state.browser,
             userID: this.props.reduxData.userInfo.username
        }

        this.setState({
            pageName: "Home",
            pageHelpURL: "Home.pdf"
        })
        //this.props.passNewPage(1)

        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        //fetch('logging', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(toSend) }).then((responseLOG) => { this.checkPageName() })
         const response = await fetch('logging', { 
             method: 'POST',
             headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
             body: JSON.stringify(toSend)
         });
        const data = await response.json();//We don't need to save the response for the logger, but handling it is something I make a habit of anyway.
        //console.log("setting global level to " + t + " from " + this.state.globalLevel)
        //this.setState({
        //    globalLevel: t //When a user changes their level, we want them to see it else they might try and keep changing it to the desired level long after the logs recognize it's changed
        //}); //Besides, this will also dictate what sites they'll have visible in their menu and if we don't let them see them, they'll effectively not have the level active

        this.props.setGlobalStateCallback(t); //This sends the new level back up to a function in Apps.js to set the global state level to the new level so that all the other components will
        //know the user's new level. Especially the component that the user has active at the moment.

        //this.levelSwitchUserFetch();
        if (!this.state.collapsed) {
            this.toggleNavbar();
        }
        
        this.getPages(t);

        this.props.updateFetchTime();
    }

    async sendDataNew(value) {
        this.setState({
            pageName: "Home",
            pageHelpURL: "Home.pdf"
        })
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            department: value,
            ip: this.props.reduxData.userInfo.ip,
            browser: this.state.browser,
        }
        const response = await fetch('DepartmentSwitch', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        let displayString = value.substring(value.indexOf("|") + 1)
        this.getPages(value.substring(0, value.indexOf("|")))
        this.props.setGlobalStateCallback(value);
        if (!this.state.collapsed) {
            this.toggleNavbar();
        }
    }

    async levelSwitchUserFetch() {
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        const response = await fetch("User", { method: "GET", headers: { 'Authorization': bearerVAR } })
        const data = await response.json();
        this.props.deptSwitch(data);

    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        deptSwitch: (e) => dispatch({ type: 'foundation/setUserData', payload: e }),
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(NavMenu);